import { inject } from '@angular/core';
import { TeamsService } from '@teams/infra';
import { Observable } from 'rxjs';
import { DeleteTeamPathParams } from '@core-http';

export class RemoveTeamCommandHandler {
  private readonly teamsService: TeamsService = inject(TeamsService);

  remove(teamId: string): Observable<void> {
    const pathParams: DeleteTeamPathParams = { teamId };

    return this.teamsService.removeTeam(pathParams);
  }
}
